var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"edit-visit-record-container"},[_vm._m(0),_c('el-card',[_c('visit-record-form',{attrs:{"record-id":_vm.recordId}})],1)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-header"},[_c('h2',[_vm._v("编辑回访记录")])])
}]

export { render, staticRenderFns }